/**
 * @generated SignedSource<<0062e28fef3c005ea5c1dd30a3b50ac7>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "ImportPublicHolidaysPayload",
            "kind": "LinkedField",
            "name": "admin_importPublicHolidays",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "success",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PublicHolidaysApiPanel_importHolidaysMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PublicHolidaysApiPanel_importHolidaysMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "f99ac06b86c1b1b05098093cce1bd38e",
            "id": null,
            "metadata": {},
            "name": "PublicHolidaysApiPanel_importHolidaysMutation",
            "operationKind": "mutation",
            "text": "mutation PublicHolidaysApiPanel_importHolidaysMutation(\n  $model: ImportPublicHolidaysRequestInput!\n) {\n  admin_importPublicHolidays(model: $model) {\n    message\n    success\n  }\n}\n"
        }
    };
})();
node.hash = "5b23a63d1a62b364352b114055d85bed";
export default node;
